import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14 1.5h-4A2.5 2.5 0 0 0 7.5 4v3A2.5 2.5 0 0 0 10 9.5h1.25v2.75H4a.75.75 0 0 0-.75.75v3.095a3.001 3.001 0 1 0 1.5 0V13.75h6.5v2.345a3.001 3.001 0 1 0 1.5 0V13.75h6.5v2.345A3.001 3.001 0 0 0 20 22a3 3 0 0 0 .75-5.905V13a.75.75 0 0 0-.75-.75h-7.25V9.5H14A2.5 2.5 0 0 0 16.5 7V4A2.5 2.5 0 0 0 14 1.5M9 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm12.5 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M12 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M5.5 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }